import { Calendar, Clock, MapPin, FileText, AlertCircle } from 'lucide-react';
import { useUserPreferences } from '@/store/useStore';
import { MobileShell, EmptyState, SectionHeader, T, numberToRoman } from '@/components/dashboard/DashboardShell';
import { useExams } from '@/hooks/useExamTimetable';

export default function ExamTimetableMobile() {
  const userPreferences = useUserPreferences();
  const { exams, isLoading } = useExams();

  return (
    <MobileShell title="Exams" subtitle="Upcoming examinations" loading={isLoading}>
      {userPreferences && (
        <div style={{
          background: T.surface, border: `1px solid ${T.border}`,
          borderLeft: `3px solid ${T.teal}`, borderRadius: 12, padding: '14px 16px',
          display: 'flex', alignItems: 'center', gap: 12,
        }}>
          <div style={{ width: 34, height: 34, borderRadius: 9, background: T.tealBg, border: `1px solid ${T.tealBorder}`, display: 'flex', alignItems: 'center', justifyContent: 'center', color: T.teal, flexShrink: 0 }}>
            <FileText size={15} />
          </div>
          <div>
            <div style={{ fontSize: 13, fontWeight: 500 }}>{userPreferences.program}</div>
            <div style={{ fontFamily: T.mono, fontSize: 9, letterSpacing: '.06em', color: T.text35, marginTop: 2 }}>
              SEM {numberToRoman(userPreferences.semester)} · GROUP {userPreferences.group}
            </div>
          </div>
        </div>
      )}

      <div style={{
        background: T.surface, border: `1px dashed ${T.border}`, borderRadius: 14,
        padding: '24px', textAlign: 'center',
      }}>
        <FileText size={22} color={T.teal} style={{ margin: '0 auto 10px', display: 'block' }} />
        <h3 style={{ fontFamily: T.serif, fontSize: 17, fontWeight: 400, margin: '0 0 6px' }}>Detailed Schedule Coming Soon</h3>
        <p style={{ fontSize: 12, color: T.text35, margin: 0, fontWeight: 300 }}>
          Complete exam schedules with times and rooms will be available before exams.
        </p>
      </div>

      <div>
        <SectionHeader title="Upcoming Exams" meta={exams.length > 0 ? `${exams.length} SCHEDULED` : undefined} />
        {exams.length === 0 ? (
          <EmptyState icon={Calendar} text="NO UPCOMING EXAMS SCHEDULED" />
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {exams.map(exam => (
              <div key={exam.id} style={{
                background: T.surface, border: `1px solid ${T.border}`,
                borderLeft: '3px solid #EF4444', borderRadius: 12, padding: '14px 16px',
              }}>
                <h4 style={{ fontSize: 13, fontWeight: 500, margin: '0 0 10px', lineHeight: 1.3 }}>{exam.title}</h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 11, color: T.text50 }}>
                    <Calendar size={11} color={T.teal} /> {exam.date}
                  </div>
                  {exam.time && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 11, color: T.text50 }}>
                      <Clock size={11} color={T.teal} /> {exam.time}
                    </div>
                  )}
                  {exam.location && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 11, color: T.text50 }}>
                      <MapPin size={11} color={T.teal} /> {exam.location}
                    </div>
                  )}
                </div>
                <div style={{ fontFamily: T.mono, fontSize: 8, letterSpacing: '.08em', color: T.text35, marginTop: 10 }}>{exam.program}</div>
              </div>
            ))}
          </div>
        )}
      </div>

      <div style={{
        background: 'rgba(96,165,250,.06)', border: '1px solid rgba(96,165,250,.2)',
        borderRadius: 12, padding: '14px 16px', display: 'flex', alignItems: 'flex-start', gap: 12,
      }}>
        <AlertCircle size={18} color="#60A5FA" style={{ flexShrink: 0, marginTop: 1 }} />
        <div>
          <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 3 }}>Important</div>
          <p style={{ fontSize: 12, color: T.text50, margin: 0, fontWeight: 300, lineHeight: 1.5 }}>
            Check with your department for specific exam schedules and room assignments.
          </p>
        </div>
      </div>
    </MobileShell>
  );
}
